/* eslint-disable @typescript-eslint/camelcase */
import { AppService } from './AbstractService';

export default class PlayerService extends AppService {
  public updatePlayer(
    id: string,
    updateData: {
      username?: string;
      password?: string;
      line_id?: string;
      bank?: string;
      status?: string;
      account_name?: string;
      account_number?: string;
      isAgent?: boolean;
      share_config?: any;
    },
  ) {
    return this.makeRequest('PUT', `/users/${id}`, updateData);
  }

  public createPlayer(data: any) {
    return this.makeRequest('POST', '/users', data);
  }

  public getPlayerById(id: string) {
    return this.makeRequest('GET', `/users/${id}`);
  }

  public getPlayerStatById(id: string) {
    return this.makeRequest('GET', `/users/stat/${id}`);
  }

  public getPlayerTurnoverByPlayerId(id: string) {
    return this.makeRequest('GET', `/promotions/turnovers/${id}`);
  }

  public getPlayerBalance(username: string) {
    return this.makeRequest('GET', `/users/balance/${username}`);
  }

  public getAffilatePlayer(id: string) {
    return this.makeRequest('GET', `/users/affiliates/${id}`);
  }

  public updateZapUser(id: string) {
    return this.makeRequest('PUT', `/zappay/users/${id}`);
  }
}
